import React, { useState } from "react";

import { GET_STANDS_CURSOR } from "graphql/query/stand-gql";

import Stands from "components/stands";
import GraphicStorage from "components/graphic-storage";
import { Tables } from "components/layout";
import { Localize } from "components/service";
import { useBreadCrumbs } from "components/use-hooks";
import { gqlBuilderWhere } from 'utils';


const basePath = GraphicStorage.Const.basePath;
const tableHelper = GraphicStorage.Helpers.TableStands;


const GraphicStorageStandsSubPage = ({ graphicStorage }) => {

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Exhibitions" }).props.children,
            path: `${ basePath }`
        },
        {
            label: graphicStorage?.title,
            path: `${ basePath }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_Stands" }).props.children,
            path: `${ basePath }/${ graphicStorage?.id }/stands`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    const routeUrl = `${ basePath }/${ graphicStorage?.id }/stands`;

    const objOrderBy = [ { column: "ID", order: "DESC" } ];

    const filterTable = 'table-graphic-storage-stands';

    const standsFilters = JSON.parse(localStorage.getItem(`standsFilters-${ filterTable }_eeID-${ graphicStorage?.id }`));
    const standsSorting = JSON.parse(localStorage.getItem(`standsSorting-${ filterTable }_eeID-${ graphicStorage?.id }`));
    const standsSearch = JSON.parse(localStorage.getItem(`standsSearch-${ filterTable }_eeID-${ graphicStorage?.id }`));

    const [ searchText, setSearchText ] = useState(standsSearch);
    const [ filters, setFilters ] = useState(gqlBuilderWhere(standsFilters));
    const [ resetSorting, setResetSorting ] = useState(false);


    return (
        <Tables.Cursor
            extraClass="table-graphic-storage-stands"
            tableLayout=""
            model="standsCursor"
            query={ GET_STANDS_CURSOR }
            varSet={ {
                perPage: 30,
                ee_id: +graphicStorage?.id,
            } }
            routeUrl={ routeUrl }
            searchText={ searchText }
            objFilter={ filters }
            objOrderBy={ standsSorting || objOrderBy }
            sortingName={ `standsSorting-${ filterTable }_eeID-${ graphicStorage?.id }` }
            tableHelper={ tableHelper }
            resetSorting={ resetSorting }
            filterTable={ filterTable }
        >
            <div className="table-action-bar">

                <div className="col">
                    <Stands.Filters.Table
                        event={ graphicStorage }
                        setSearchText={ setSearchText }
                        setFilters={ setFilters }
                        filters={ filters }
                        standsFilters={ standsFilters }
                        searchText={ searchText }
                        setResetSorting={ setResetSorting }
                        objOrderBy={ objOrderBy }
                        excludeFields={ [ 'HALL_ID' ] }
                        filterTable={ filterTable }
                    />
                </div>

                <div className="col">

                </div>
            </div>
        </Tables.Cursor>
    );
};

export default GraphicStorageStandsSubPage;
